<template>
  <article class="prose">
    <template v-for="section in article">
      <template v-for="block in section">
        <span v-if="block.text">{{ block.text }}</span>
        <p v-else-if="block.linebreak" />
        <template v-else-if="block.h4">
          <h4 :id="block.h4.toLocaleLowerCase().replaceAll(' ', '-')">
            {{ block.h4 }}
          </h4>
        </template>
        <template v-else-if="block.h3">
          <h3 :id="block.h3.toLocaleLowerCase().replaceAll(' ', '-')">
            {{ block.h3 }}
          </h3>
        </template>
        <template v-else-if="block.h2">
          <h2 :id="block.h2.toLocaleLowerCase().replaceAll(' ', '-')">
            {{ block.h2 }}
          </h2>
        </template>
        <template v-else-if="block.h1">
          <h1 :id="block.h1.toLocaleLowerCase().replaceAll(' ', '-')">
            {{ block.h1 }}
          </h1>
        </template>
        <BedeLink
          v-else-if="block.link"
          :to="block.link.href"
          :external="block.link.external"
        >
          {{ block.link.label }}
        </BedeLink>
        <p v-else-if="block.quote">
          <q>
            {{ block.quote }}
          </q>
        </p>
        <ol v-else-if="block.ol">
          <li v-for="li in block.ol">{{ li }}</li>
        </ol>
        <ul v-else-if="block.ul">
          <li v-for="li in block.ul">{{ li }}</li>
        </ul>
      </template>
    </template>
  </article>
</template>

<script setup lang="ts">
import type Article from "@/types/Article";

const props = defineProps<{ article: Article }>();
</script>
